export const layoutTypes = {
  twoColumns: 'TWO_COLUMNS',
  threeColumns: 'THREE_COLUMNS',
};
